<section class="products-promo" *ngIf="product$()">
    <div class="d-flex flex-lg-row flex-column gap-24">
        <div class="col-12 col-lg-6 p--0 d-flex flex-column align-items-start justify-content-center">
            <ng-container *ngIf="product$().image">
                <div class="product-icon mb--24">
                    <img [ngSrc]="product$().thumb" width="64" height="64" [attr.alt]="'products-overview'" priority>
                </div>
            </ng-container>
            <h3 class="promo-section-title">{{ product$().title }}</h3>
            <div class="promo-description mb--24" [innerHTML]="product$().description"></div>
            <button mat-stroked-button color="primary" (click)="clickAction()">Scopri di più</button>
        </div>
        <div class="button-product active col-12 col-lg-6">
            <img [ngSrc]="product$().image" width="680" height="474" [attr.alt]="'products-overview'" class="rounded img-responsive" priority>
        </div>
    </div>
</section>